module.exports = __webpack_public_path__ + "static/media/fruits_13.45f20fbd.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_13.csv
// module id = 677
// module chunks = 0